import { AnalyticsService } from '@analytics/feature';
import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ServiceItemCarouselItem } from '@promo/const';

@Component({
  selector: 'sd-service-carousel-item',
  imports: [RouterLink, NgOptimizedImage],
  templateUrl: './service-carousel-item.component.html',
  styleUrls: ['./service-carousel-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceCarouselItemComponent {
  @Input() serviceCarouselItem: ServiceItemCarouselItem;
  private analyticsService = inject(AnalyticsService);

  onClickService(item: ServiceItemCarouselItem): void {
    this.analyticsService.sendEvent({
      event: 'click_services',
      service_name: item.buttonText,
    });
  }
}
